export default {
    parameters: {
        landing_id: "IDMathAB",
    },
    downtimeUrl: "https://id2.kodland.tech",
    startPage: {
      image: {
        url:  "/welcome/quiz_indo_early_math.jpeg",
        style: {
          width: "100%",
          "max-height": "100vh",
      }
      },
      imageMobile: {
        url: "/welcome/quiz_indo_early_math.jpeg",
        style: {
          width: "100%",
        },
      },
      title: "Jawab 3 pertanyaan berikut dan dapatkan kelas matematika seru GRATIS",
      subtitle:
        "<div style=”line-height:0.5;”>Di Kelas, kami akan: <br>• Mengenalkan cara belajar matematika melalui game <br>• Mengidentifikasi tingkat pemahaman anak</div></li>",
      button: "Mulai  🚀",
    },
    successPage: {
      title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran 🚀 GRATIS 🚀",
      subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
      button: "📆 Pesan",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Terima kasih karena sudah mempercayakan kami sebagai platform edukasi Anda! Sayangnya, tablet atau handphone tidak dapat digunakan untuk mengikuti pembelajaran kami. Dengan senang hati kami akan menantikan kehadiran Anda kembali di kelas!",
    },
    quizRotateBySteps: {
      1: {
        question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
        answers: [
          "📱 Bermain game di HP atau komputer",
          "👽 Menonton kartun",
          "♟️ Bermain permainan papan",
          "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
          "👥 Menghabiskan waktunya dengan teman",
          "⛹️ Bermain kegiatan olahraga",
          "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
        ],
      },
      2: {
        question: "Apakah anak Anda memiliki pengalaman belajar matematika, logika, atau aritmatika sebelumnya?",
        answers: [
          "🏫 Ya, belajar di sekolah",
          "👧 Ya, belajar sendiri atau dibimbing orang tua",
          "👩‍🏫 Ya, belajar di tempat les/kursus",
          "🙅‍♀️ Tidak, tidak ada pengalaman",
        ],
      },
      3: {
        question: "Apa yang ingin Anda dapatkan di kelas pertama gratis ini?",
        answers: [
          "👩‍🏫  Belajar cara mengajarkan matematika kepada anak",
          "🔢 Mengetahui tingkat kemampuan anak",
          "🎯 Belajar untuk mengatasi situasi sulit",
          "📈 Meningkatkan motivasi anak",
          "🎲 Belajar cara mengajarkan matematika melalui game seru kepada anak",
        ],
      },
      4: {
        question: "Menurut Anda, apa yang paling penting dalam pendidikan anak Anda?",
        answers: [
          "🤩 Aktivitas interaktif dan menyenangkan",
          "🚀 Kualitas edukasi",
          "👧 Pendekatan individu",
          "💵 Perbandingan harga/kualitas",
          "👩‍🏫 Guru yang ahli",
        ],
      },
      5: {
        question: "Apakah Anda dapat terhubung ke kelas uji coba gratis dari komputer atau laptop?",
        answers: [
          {
            answer: "💻 Ya",
            distribution_tag_question: [16]
          }, 
          {
            answer: "😐 Tidak",
            stopAnswer: true
          },
        ],
      },
    },
  };
  